import { FC, ReactNode } from "react";

import { BusyIndicator } from "./BusyIndicator";
import { DiscussionView } from "./DiscussionView";
import { EmptyState } from "./EmptyState";

import { AgentChatMessage, ChatbotClassMap, ChatbotCx } from "../types";

interface Props {
  readonly styles: ChatbotClassMap;
  readonly cx: ChatbotCx;
  readonly hasMessages: boolean;
  readonly currentMessages: readonly AgentChatMessage[];
  readonly isLoading: boolean;
  readonly introTitle: ReactNode;
  readonly introSubtitle: ReactNode;
  readonly introPresets?: readonly string[];
  readonly currentInputValue: string;
  readonly onPresetSelect: (preset: string) => void;
  readonly onSuggestionSelect: (suggestion: string) => void;
}

/** Renders either the intro state or the active discussion transcript with loading indicator. */
export const ConversationContent: FC<Props> = ({
  styles,
  cx,
  hasMessages,
  currentMessages,
  isLoading,
  introTitle,
  introSubtitle,
  introPresets,
  currentInputValue,
  onPresetSelect,
  onSuggestionSelect,
}) => {
  if (!hasMessages) {
    return (
      <EmptyState
        styles={styles}
        introTitle={introTitle}
        introSubtitle={introSubtitle}
        introPresets={introPresets}
        currentInputValue={currentInputValue}
        onPresetSelect={onPresetSelect}
      />
    );
  }

  return (
    <>
      <DiscussionView
        styles={styles}
        cx={cx}
        messages={currentMessages}
        onSuggestionSelect={onSuggestionSelect}
      />
      {!!isLoading && <BusyIndicator styles={styles} />}
    </>
  );
};
